<template>
	<section class="section-form">
		<div class="wrapper">
			<div v-if="page !== pages.CONFIRMATION">
				<the-form-postcard/>
				<the-form-navigation :page="page" />
			</div>
			<transition name="fade">
				<the-form-message
					@success="show(pages.GIFT)"
					v-if="page === pages.MESSAGE"
				/>
				<the-form-gift
					v-if="page === pages.GIFT"
					@success="show(pages.PAYMENT)"
					@back="show(pages.MESSAGE)"
				/>
				<the-form-payment
					v-if="page === pages.PAYMENT"
					@success="show(pages.CONFIRMATION)"
					@back="show(pages.GIFT)"
				/>
				<the-form-confirmation
					v-if="page === pages.CONFIRMATION"
				/>
			</transition>
		</div>
	</section>
</template>

<script>
import { pages } from '@/constants';
import ButtonRight from '../ButtonRight';
import ButtonLeft from '../ButtonLeft';
import TheFormPostcard from './TheFormPostcard';
import TheFormNavigation from './TheFormNavigation';
import TheFormMessage from './TheFormMessage';
import TheFormGift from './TheFormGift';
import TheFormPayment from './TheFormPayment';
import TheFormConfirmation from './TheFormConfirmation';

export default {
	components: { ButtonRight, ButtonLeft, TheFormPostcard, TheFormNavigation, TheFormMessage, TheFormGift, TheFormPayment, TheFormConfirmation },
	data () {
		return {
			page: pages.MESSAGE,
		};
	},
	computed: {
		pages () {
			return pages;
		},
	},
	methods: {
		show (slug) {
			this.page = slug;
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';

	section { width: 50%; background-color: @greyLight; color: @grey; }
	.wrapper { display: inline-block; max-width: 350px; width: 350px; margin: 70px 0 3vw 118px; text-align: center; }
	.fade-enter-active {
		transition: opacity 1s
	}
	.fade-enter {
		opacity: 0;
	}

	@media @tablet {
		section { width: 100%; }
		.wrapper { display: block; margin: 70px auto; }
	}

	@media @mobile {
		section { width: 100%; }
		.wrapper { margin: 0; width: 100%; max-width: unset; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheForm.vue